module.exports = __webpack_public_path__ + "img/user3.d89e5759.jpg";